const order = {
  type: {
    XPRESS: 0,
    AUTO: 1,
  },
};

export default order;
